import Component from '../core/Component'
import throttle from 'lodash/throttle'
import EventBus from '../core/EventBus'
import { substitute } from '../utils/String'

export const STATES = {
    DRAGGING: 'is-dragging'
}

export default class RangeSlider extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            input: null,
            axisMin: null,
            axisMax: null,
            tooltip: null
        }

        this.handleResize = throttle(this.handleResize, 100)
        this.ready = false
        this.isDragging = false
        this.tooltipTemplate = '{value}'
    }

    prepare() {
        this.ready = true
        this.ref.input.addEventListener('change', this.handleInput)
        this.ref.input.addEventListener('input', this.handleInput)
        this.element.addEventListener('mousedown', this.handlePointerDown)
        this.element.addEventListener('touchstart', this.handlePointerDown)
        this.element.addEventListener('mouseup', this.handlePointerUp)
        this.element.addEventListener('touchend', this.handlePointerUp)
        this.element.addEventListener('touchcancel', this.handlePointerUp)
        window.addEventListener('resize', this.handleResize)
        this.resize()
        this.render()

        if (this.ref?.tooltip?.dataset?.template) {
            this.tooltipTemplate = this.ref.tooltip.dataset.template
        }

        EventBus.on('tabs:change', this.handleTabChange)
    }

    destroy() {
        EventBus.off('tabs:change', this.handleTabChange)
        window.removeEventListener('resize', this.handleResize)
    }

    handleTabChange = () => {
        this.resize()
        this.render()
    }

    handleInput = () => {
        this.render()
        this.emit('change', {
            value: this.ref.input.value
        })
    }

    handleResize = () => {
        this.resize()
        this.render()
    }

    handlePointerDown = () => {
        this.dragStart()
    }

    handlePointerUp = () => {
        this.dragStop()
    }

    resize() {
        this.box = this.ref.input.getBoundingClientRect()
    }

    render() {
        if (!this.ready) {
            return
        }

        const min = parseInt(this.ref.input.min)
        const max = parseInt(this.ref.input.max)
        const value = parseInt(this.ref.input.value)
        const offset = (value - min)/(max - min)
        this.ref.input.style.backgroundPosition = `${(offset * this.box.width + (1 - offset) * 10 - offset * 9) - this.box.width}px 0px`

        if (this.ref.tooltip) {
            this.ref.tooltip.style.left = `${offset * this.box.width + (1 - offset) * 8 - offset * 8}px`
            this.ref.tooltip.innerText = substitute(this.tooltipTemplate, {
                value: value
            })
        }
    }

    dragStart() {
        if (!this.isDragging) {
            this.isDragging = true
            this.element.classList.add(STATES.DRAGGING)
        }
    }

    dragStop() {
        if (this.isDragging) {
            this.isDragging = false
            this.element.classList.remove(STATES.DRAGGING)
        }
    }

    set(options, withEvent = false) {
        if ('value' in options) {
            this.ref.input.value = options.value
        }

        if ('min' in options) {
            this.ref.input.min = options.min
        }

        if ('axisMin' in options && this.ref.axisMin) {
            this.ref.axisMin.innerText = options.axisMin
        }

        if ('max' in options) {
            this.ref.input.max = options.max
        }

        if ('axisMax' in options && this.ref.axisMax) {
            this.ref.axisMax.innerText = options.axisMax
        }

        if (withEvent) {
            this.handleInput()
        } else {
            this.render()
        }
    }

    getLimits() {
        return {
            min: parseInt(this.ref.input.min),
            max: parseInt(this.ref.input.max)
        }
    }
}